import React from 'react';
import { useTexts } from '../data';

const Header = () => {
  const TEXTS = useTexts();

  return (
    <header className="modern-header py-3" data-component="Header">
      <div className="text-center">
        <h1 className="temple-title mb-1">{TEXTS.TEMPLE_NAME}</h1>
        <div className="temple-subtitle mb-2">{TEXTS.TEMPLE_SUBTITLE}</div>
        <div className="temple-location mb-2">
          <span className="location-icon">📍</span>
          {TEXTS.TEMPLE_LOCATION}
        </div>
        <div className="celebration-banner">{TEXTS.TEMPLE_CELEBRATION}</div>
      </div>
    </header>
  );
};

export default Header;
